<ng-container *ngIf="!loading">
  <div class="suggestions-video-box">
    <a [routerLink]="link">
      <div class="img-wrapper" [style.background]="getBackgroundStyleFormated(url)">
        <div class="total-time" *ngIf="totaltime">
          <span>{{modifyDuration(totaltime)}}</span>
        </div>
      </div>

      <div class="suggestions-video-box__overlay"></div>
    </a>

    <div class="suggestions-video-box__text">
      <div class="text-content">
        <h3 class="title">{{ title }}</h3>
        <p class="subtitle" *ngIf="instrutor">Instrutor: <span>{{ instrutor }}</span></p>
      </div>
      <div class="status-tag" *ngIf="free">
        <div class="free-tag">
          <span>FREE</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="loading">
  <div class="suggestions-video-box">
    <div class="loading-top"></div>

    <div class="loading-bot">
      <div class="line unh-shine l-244"></div>
      <div class="line unh-shine l-160"></div>
    </div>
  </div>
</ng-container>

